
import Tinymce from '@/components/Tinymce';

export default {
  // 描述文字
  name: 'WkDescText',

  components: {
    Tinymce: Tinymce
  },

  inheritAttrs: false,

  props: {},

  data: function data() {
    return {};
  },


  computed: {},

  watch: {},

  created: function created() {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},


  methods: {}
};